'use strict';
import angular from 'angular';

import facebookAdsLocatioHtmlUrl from './views/facebookAdsLocation.list.html';
import {AppConfig} from "../../../../ioclient/app/scripts/shared/app.constants";

var app = angular.module('app.facebookAdsLocations.component', []);

app.component('facebookAdsLocationWidget', {
    bindings: {
        selectedFbGeoLocations : '=',
        clusterId : '=',
        showActions : '='
    },
    templateUrl: facebookAdsLocatioHtmlUrl,

    // The controller that handles our component logic
    controller: function($scope,$ioAlert, anchorSmoothScroll, $location, $timeout,$stateParams,FormService,ClusterService) {
        var self = this;
        self.orderId = $stateParams.orderId;
        self.rootLocation = { "id": 0, "children": "1", "criteria": "" };
        self.navFbLocations = [];
        self.previousLocationData = [];
        self.geolocSearch = "";
        self.breadcrumbs = [];
        self.collectedNodes = [0];
        self.includeOrExcludeLocation = null;
        var geoLocationsCount = 0;
        self.selectedListOfLocations = [];

        self.showTabPanel = true;
        self.selectedInput = {
            value: 'fb_locations'                
        }                
        self.geoTextInputs = {   
            inputValues: ''
        }                
        self.textInputOptions = ["US Postal Codes", "US States", "US Cities"];
        self.textInputObj = {                    
            textInputType: "US Postal Codes"
       }                
       self.selectedCriteria = {
            criteria: ""                
        };               
        self.criteria = ["include all", "exclude all"];
        self.showError = false;                                
        self.toggleComponent = function(selectedOption) {                    
            self.selectedInput.value = selectedOption; 
       }
        $scope.$watch('$ctrl.geoTextInputs.inputValues', function() {
            if(self.geoTextInputs.inputValues.length == 0) {
                self.showError = false;
            }
        });

        $scope.$watchCollection('$ctrl.selectedFbGeoLocations.selFbLocationPickers', function (newCol, oldCol, scope) {
            _.map(newCol, function (item) { 
                    item.selectedInput = "fb_textInput"; 
                    self.selectedListOfLocations.push(item) 
            })
            self.selectedListOfLocations  = _.uniq(self.selectedListOfLocations);
        })

        $scope.$watchCollection('$ctrl.selectedFbGeoLocations.selFbTextInputs', function (newCol, oldCol, scope) {
            _.map(newCol, function (item) { self.selectedListOfLocations.push(item) })
            self.selectedListOfLocations = _.uniq(self.selectedListOfLocations);           
        })

        self.handleChangeTextInput = function() {
            self.geoTextInputs.inputValues = '';
            self.showError = false;
        }

        /*
        * Handle validate postal codes
        */
        self.validateInputValues = function () {
            if (self.textInputObj.textInputType == "US Postal Codes") {
                var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
                var filteredValues = geoValues.filter(function (el) {
                    return el != "";
                });
                FormService.validateFbPostalCodes(filteredValues, self.clusterId).then(function (data) {
                    if (data) {
                        processTextInputs(data);
                    }
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else if (self.textInputObj.textInputType == "US States") {
                var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
                var filteredValues = geoValues.filter(function (el) {
                    return el != "";
                });
                FormService.validateFbUsStates(filteredValues, self.clusterId).then(function (data) {
                    if (data) {
                        processTextInputs(data);
                    }
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else if (self.textInputObj.textInputType == "US Cities") {
                var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
                var filteredValues = geoValues.filter(function (el) {
                    return el != "";
                });
                FormService.validateFbUsCities(filteredValues, self.clusterId).then(function (data) {
                    if (data) {
                        processTextInputs(data);
                    }
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }

        }

        /*
        * Handle process GET response
        */
       var processTextInputs = function(response) {
            if(response.valid && response.valid.length > 0) {
                _.each(response.valid, function(validGeoValue) {
                    validGeoValue.geoType = self.textInputObj.textInputType;
                    validGeoValue.criteria_link = 'included';
                    self.selectedFbGeoLocations.selFbTextInputs.push(validGeoValue);
                })
                self.geoTextInputs.inputValues = '';
            } 
            
            if(response.invalid && response.invalid.length > 0){
                self.showError = true;
                self.geoTextInputs.inputValues = response.invalid.toString();
            }
        }

        self.getPostalCodesTooltips=function(selFbTextInputs){
            var data = angular.copy(selFbTextInputs);
                data = data.slice(5);
            var html=angular.element("<ul/>");
            angular.forEach(data,function(item){
              html.append("<li style='list-style:none;'>"+item.name+"</li>");
            });
            return html.html();
        
          };

          self.getLocationTooltips=function(locations){
            var data = angular.copy(locations);
                data = data.slice(2);
            var html=angular.element("<ul/>");
            angular.forEach(data,function(item){
              html.append("<li style='list-style:none;'>"+item.full_name+"</li>");
            });
            return html.html();
        
          };

        /*
        * Handle remove selected text inputs
        */
        self.removeTextInputs = function(removeItem) {
            var selIndex = _.findIndex(self.selectedFbGeoLocations.selFbTextInputs, {external_id: removeItem.external_id});
            if (selIndex >= 0) {
                self.selectedFbGeoLocations.selFbTextInputs.splice(selIndex, 1);
            }
        }

        /*
        * Handle Clear All Text Inputs
        */
        self.handleClearAllInputs = function() {
            self.selectedFbGeoLocations.selFbTextInputs = [];
        }

        self.handleClearSelectedLocations = function() {
            self.selectedFbGeoLocations.selFbLocationPickers = [];
            self.selectedFbGeoLocations.selFbTextInputs = [];
            self.selectedListOfLocations = [];
            self.selectedCriteria.criteria = 'none';
            geoLocationsCount = 0;
            self.includeOrExcludeLocation = null;
            _.each(self.navFbLocations, function(navLocation) {
                navLocation.criteria = '';
                navLocation.criteria_link = 'include';
            });
        }

        self.handleChangeCriteria = function() {
            self.selectedFbGeoLocations.selFbLocationPickers = [];
            if(self.selectedCriteria.criteria == 'include all') {
                _.each(self.navFbLocations, function(navLocation) {
                    navLocation.criteria = 'include';
                    navLocation.criteria_link = 'included';
                    navLocation.full_name = self.buildFullName(navLocation);
                    self.selectedFbGeoLocations.selFbLocationPickers.push(navLocation);
                });
            } else if(self.selectedCriteria.criteria == 'exclude all') {
                _.each(self.navFbLocations, function(navLocation) {
                    navLocation.criteria = 'exclude';
                    navLocation.criteria_link = 'excluded';
                    navLocation.full_name = self.buildFullName(navLocation);
                    self.selectedFbGeoLocations.selFbLocationPickers.push(navLocation);
                });
            } else {
                _.each(self.navFbLocations, function(navLocation) {
                    navLocation.criteria = '';
                    navLocation.criteria_link = 'include';
                });
            }
        }

        self.getChildrenNodes = function(item) {
            if (item.children > 0) {
               if (self.collectedNodes.indexOf(item.id) < 0) {
                    FormService.getFbGeoLocationsById(self.orderId,self.clusterId,item.country_code).then(function(success) {
                        self.collectedNodes.push(item.id);
                        self.locations = self.locations.concat(success);
                        self.getLocationChilds(item);
                        self.geolocSearch = "";
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                 } else {
                     self.getLocationChilds(item);
                 }
            }
        };

        self.showtabPanel = function() {
            self.showTabPanel = !self.showTabPanel;
        }

        self.getLocationChilds = function(item) {
            if (item.children > 0) {
                self.navFbLocations = [];
                if (self.locations) {
                    for (var i = 0, len = self.locations.length; i < len; i++) {
                        if (self.locations[i].parent_id == item.id) {
                            if (self.selectedFbGeoLocations.selFbLocationPickers.length > 0) {
                               var selIndex = _.findIndex(self.selectedFbGeoLocations.selFbLocationPickers, { id: self.locations[i].id });
                                if (selIndex !== -1) {
                                    self.locations[i].criteria = self.selectedFbGeoLocations.selFbLocationPickers[selIndex].criteria;
                                    self.includeOrExcludeLocation = self.selectedFbGeoLocations.selFbLocationPickers[selIndex].criteria + 'location';
                                }
                            } else{
                                self.locations[i].criteria = "";
                            }
                            if (self.locations[i].criteria.length == 0 && item.criteria.length > 0) {
                                self.locations[i].criteria = item.criteria;
                            }
                            self.locations[i].criteria_link = 'include';
                            if (self.locations[i].criteria == "include") {
                                self.locations[i].criteria_link = 'included';
                            } else if (self.locations[i].criteria == "exclude") {
                                self.locations[i].criteria_link = 'excluded';
                            }
                            self.navFbLocations.push(self.locations[i]);
                            self.checkingCriteria();
                       }
                    }
                    self.previousLocationData = angular.copy(self.navFbLocations);
                }
                self.breadcrumbs = [];
                self.buildBreadcrumbs(item);
            }
        }

        self.changeIncludeExclude = function(item, criteria) {
            var index = self.navFbLocations.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    self.navFbLocations[index].criteria = 'include';
                    self.navFbLocations[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    self.navFbLocations[index].criteria = 'exclude';
                    self.navFbLocations[index].criteria_link = 'excluded';
                } else {
                    self.navFbLocations[index].criteria = '';
                    self.navFbLocations[index].criteria_link = 'include';
                }
                if(geoLocationsCount < 1) {
                    self.includeOrExcludeLocation = criteria + 'location';
                }
                var selIndex = _.findIndex(self.selectedFbGeoLocations.selFbLocationPickers, { id: self.navFbLocations[index].id });
                self.navFbLocations[index].full_name = self.buildFullName(self.navFbLocations[index])
                if (selIndex >= 0) {
                    self.selectedFbGeoLocations.selFbLocationPickers[selIndex] = self.navFbLocations[index];
                } else {
                    self.selectedFbGeoLocations.selFbLocationPickers.push(self.navFbLocations[index]);
                }
                changeAllChildCriteria(self.navFbLocations[index].id, self.navFbLocations[index].criteria);
                for(var i=0; i<self.selectedFbGeoLocations.selFbLocationPickers.length; i++){
                    var parentId = parseInt(self.selectedFbGeoLocations.selFbLocationPickers[i].parent_id);
                    var parentObj = _.find(self.locations, {id: parentId});

                    if(parentObj && parentObj.criteria === self.selectedFbGeoLocations.selFbLocationPickers[i].criteria ){
                        self.selectedFbGeoLocations.selFbLocationPickers.splice(i, 1);
                    }
                }
                geoLocationsCount++;
            }
        }

        self.removeLoc = function (item) {
            if (item.selectedInput == "fb_textInput") {
                var selIndex = self.selectedFbGeoLocations.selFbLocationPickers.indexOf(item);
                self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
                if (selIndex >= 0) {
                    self.selectedFbGeoLocations.selFbLocationPickers.splice(selIndex, 1);
                    if (self.selectedFbGeoLocations.selFbLocationPickers.length == 0) {
                        geoLocationsCount = 0;
                        self.includeOrExcludeLocation = null;
                    }
                }
                var parentId = parseInt(item.parent_id);
                var parentLocation = _.find(self.locations, { id: parentId });
                var locationObj = _.find(self.locations, { id: item.id });
                if (locationObj) {
                    if (parentLocation) {
                        if (parentLocation.criteria == "include") {
                            locationObj.criteria = 'include';
                            locationObj.criteria_link = 'included';
                        } else if (parentLocation.criteria == "exclude") {
                            locationObj.criteria = 'exclude';
                            locationObj.criteria_link = 'excluded';
                        } else {
                            locationObj.criteria = '';
                            locationObj.criteria_link = 'include';
                        }
                    } else {
                        locationObj.criteria = '';
                        locationObj.criteria_link = 'include';
                        for (var k = 0; k < self.navFbLocations.length; k++) {
                            if (self.navFbLocations[k].name == item.name) {
                                self.navFbLocations[k].criteria = '';
                                self.navFbLocations[k].criteria_link = 'include';
                                break;
                            }
                        }
                        self.previousLocationData = angular.copy(self.navFbLocations);
                    }
                    changeAllChildCriteria(item.id, locationObj.criteria);
                } else {
                    for (var k = 0; k < self.navFbLocations.length; k++) {
                        if (self.navFbLocations[k].name == item.name) {
                            self.navFbLocations[k].criteria = '';
                            self.navFbLocations[k].criteria_link = 'include';
                            break;
                        }
                    }
                }
                for (var i = 0; i < self.selectedFbGeoLocations.selFbLocationPickers.length; i++) {
                    if (self.selectedFbGeoLocations.selFbLocationPickers[i].parent_id == String(item.id)) {
                        self.selectedFbGeoLocations.selFbLocationPickers.splice(i, 1);
                    }
                }
            } else {
                var selIndex = _.findIndex(self.selectedFbGeoLocations.selFbTextInputs, {id: item.id});
                if (selIndex >= 0) {
                    self.selectedFbGeoLocations.selFbTextInputs.splice(selIndex, 1);
                    self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
                }
            }
        }

        function changeAllChildCriteria(parentId, criteria = ""){
            _.each(self.locations, function(location){
                if(location.parent_id==parentId){
                    if(criteria == "include"){
                        location.criteria = 'include';
                        location.criteria_link = 'included';
                    }else if(criteria == "exclude"){
                        location.criteria = 'exclude';
                        location.criteria_link = 'excluded';
                    }else{
                        location.criteria = '';
                        location.criteria_link = 'include';
                    }
                    changeAllChildCriteria(location.id, location.criteria);
                }
            });
        }

        //searching loacgtion by Searvices
        self.searchFbLocation = function (geolocSearch) {
            if (event.keyCode != 13) {
                if (geolocSearch.length > 0) {
                    FormService.getFbGeoSearchloctions(geolocSearch,self.clusterId).then(function (success) {
                        if (success && success.length > 0) {
                            self.searchData = success;
                            self.navFbLocations = [];
                            _.each(self.searchData, function (item, i) {
                                var index = self.locations.findIndex(x => x.id == item.id);
                                if (index > -1) {
                                    self.navFbLocations.push(self.locations[index]);
                                }
                                else {
                                    self.navFbLocations[i] = item;
                                    self.navFbLocations[i].criteria = "";
                                    self.navFbLocations[i].criteria_link = 'include';
                                    self.navFbLocations[i].name = item.name;
                                    self.navFbLocations[i].parent_name = item.parent_name;
                                }
                            });
                            self.checkingCriteria();
                        }
                    }, function (error) {

                    });
                }else{
                    if (geolocSearch.length == 0) {
                        self.searchData = [];
                        self.navFbLocations = [];
                        self.navFbLocations = angular.copy(self.previousLocationData);
                        self.checkingCriteria();
                    }
                }
            }
            else if (event.keyCode == 8) {
                if (geolocSearch.length == 0) {
                    self.searchData = [];
                    self.navFbLocations = [];
                    self.navFbLocations = angular.copy(self.previousLocationData);
                    self.checkingCriteria();
                }
            }
        }
        self.checkingCriteria = function(){
            for(var k=0;k<self.selectedFbGeoLocations.selFbLocationPickers.length;k++){
                for(var j=0;j<self.navFbLocations.length;j++){
                    if(self.selectedFbGeoLocations.selFbLocationPickers[k].name == self.navFbLocations[j].name){
                        if (self.selectedFbGeoLocations.selFbLocationPickers[k].criteria == "include") {
                            self.navFbLocations[j].criteria = 'include';
                            self.navFbLocations[j].criteria_link = 'included';
                        } else if (self.selectedFbGeoLocations.selFbLocationPickers[k].criteria == "exclude") {
                            self.navFbLocations[j].criteria = 'exclude';
                            self.navFbLocations[j].criteria_link = 'excluded';
                        }else{
                            self.navFbLocations[j].criteria = '';
                            self.navFbLocations[j].criteria_link = 'include';
                        }
                    }
                }
            }
        }

        self.buildBreadcrumbs = function(item) {
            if (item.parent_id || item.parent_id == 0) {
                self.breadcrumbs.unshift(item);
                if (item.parent_id == 0) {
                    return false;
                } else {
                    var obj = _.find(self.locations, function(loc) {
                        return loc.id == item.parent_id
                    });
                    self.buildBreadcrumbs(obj);
                }
            }
        }

        self.buildFullName = function(item) {
            if (item.parent_id == 0) {
                return item.name + ".";
            } else {
                var obj = _.find(self.locations, function(loc) {
                    return loc.id == item.parent_id
                });
                if(obj == undefined && item.parent_name){
                    return item.name + " , " + item.parent_name +"."
                } else {
                    return item.name + ", " + self.buildFullName(obj);

                }
            }
        }

        var getLocations = function() {
            FormService.getFbGeoLocationsById(self.orderId,self.clusterId,null).then(function(success) {
                self.locations = success;
                self.getLocationChilds(self.rootLocation);
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        };

        var initLocations = function() {
            if(self.selectedFbGeoLocations && !_.isEmpty(self.selectedFbGeoLocations)){
                self.selectedFbGeoLocations = JSON.parse(self.selectedFbGeoLocations);
                if(self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    getLocations();
                    if(self.selectedFbGeoLocations.selFbTextInputs && self.selectedFbGeoLocations.selFbTextInputs.length > 0){
                        self.textInputObj.textInputType = self.selectedFbGeoLocations.selFbTextInputs[0].geoType ? self.selectedFbGeoLocations.selFbTextInputs[0].geoType : "US Postal Codes";
                     }
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedFbGeoLocations = {
                    selFbLocationPickers: [],
                    selFbTextInputs: []
                };
                self.enableViewMode = false;
                self.editMode = false;
                getLocations();
            }
        };

        initLocations();
    }
});